import { create } from 'zustand';
import type { ArtifactPreviewStore } from './artifactPreview.store.types';

const INITIAL_OPEN_STATE = {
  openArtifactId: null,
  openArtifactName: null,
  openArtifactKind: null,
  openArtifactKey: null,
} as const;

export const useArtifactPreviewStore = create<ArtifactPreviewStore>((set) => ({
  ...INITIAL_OPEN_STATE,
  // `listQuery` lives outside `INITIAL_OPEN_STATE` because closing the modal
  // shouldn't clear the snapshot — the grid is still mounted with the same
  // query, and the next open() should resolve nav against it without
  // requiring Library to re-publish via the setter.
  listQuery: null,
  open: (id, name, kind, artifactKey) =>
    set({
      openArtifactId: id,
      openArtifactName: name,
      openArtifactKind: kind,
      openArtifactKey: artifactKey,
    }),
  close: () => set(INITIAL_OPEN_STATE),
  setListQuery: (query) => set({ listQuery: query }),
}));
